"use client";

import dynamic from "next/dynamic";
import BackButton from "./BackButton";
import styles from "@/assets/css/pages/font.module.css";
import VehicleSelectionForm from "./VehicleSelectionForm";
import useVehicleController from "@/lib/hooks/useVehicleController";

const OilProgressBar = dynamic(() => import("../OilProgressBar"));
const CompatibilityInfo = dynamic(() => import("./CompatibilityInfo"));

const CurrentVehicle = ({
  cookieKeys,
  heading = "",
  isPDP = false,
  subHeading = "",
  hideForm = false,
  searchParams = {},
  selectedMake = {},
  selectedModel = {},
  isCompatible = false,
  isSearchPage = false,
  categoryHeading = "",
  hasManualLook = false,
  selectedVehicle = null,
  categoryBreadcrumbs = [],
  compatibleChecked = false,
  handleShowProducts = () => {},
}) => {
  const {
    data: { t, manual, showOilBar, userVehicle, updatedTitle, vehicleDetail },
    methods: { updatePageTitle, handleChangeVehicle, removeManualSelection },
  } = useVehicleController({
    heading,
    cookieKeys,
    searchParams,
    hasManualLook,
    categoryHeading,
    selectedVehicle,
    categoryBreadcrumbs,
  });

  return (
    <section className={`vehicle-header ${userVehicle ? 'xs:min-h-[157px] min-h-[131px]': 'xl:min-h-[220.8px] lg:min-h-[390px] xs:min-h-[380px] min-h-[316px]'}`}>
      <div className="container">
        <div className="row">
          <div className="col w-12/12">
            <BackButton
              t={t}
              isPDP={isPDP}
              styles={styles}
              heading={heading}
              subHeading={subHeading}
              updatedTitle={updatedTitle}
              isSearchPage={isSearchPage}
            />
            <div className="flex flex-col">
              <div className="xs:order-1 order-2">
                {!hideForm && (
                  <div
                    id="current-vehicle"
                    className={`current-vehicle-card ${
                      isPDP &&
                      userVehicle &&
                      compatibleChecked &&
                      !isCompatible &&
                      "border-danger"
                    }`}
                  >
                    <div>
                      {!userVehicle ? (
                        <div className="xl:min-h-[90px] xs:min-h-[260px] min-h-[175px]">
                          <p className="text-body-text-1-sb mb-[12px] text-tertiary-black sm:pt-0 pt-[6px]">
                            {t("current_vehicle.title")}
                          </p>
                          <VehicleSelectionForm
                            t={t}
                            hasManualLook={manual}
                            selectedMake={selectedMake}
                            selectedModel={selectedModel}
                            updatePageTitle={updatePageTitle}
                            removeManualSelection={removeManualSelection}
                          />
                        </div>
                      ) : (
                        <CompatibilityInfo
                          t={t}
                          isPDP={isPDP}
                          isCompatible={isCompatible}
                          vehicleDetail={vehicleDetail}
                          compatibleChecked={compatibleChecked}
                          handleShowProducts={handleShowProducts}
                          handleChangeVehicle={handleChangeVehicle}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="xs:order-2 order-1">
                {showOilBar && <OilProgressBar vehicle={userVehicle} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CurrentVehicle;
